import { render, staticRenderFns } from "./ProductCategoryImages.vue?vue&type=template&id=7b88235c&"
import script from "./ProductCategoryImages.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports